module.exports = "<p>\r\n  reportfilter works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/myreports/reportfilter/reportfilter.component.html
// module id = ./src/app/myreports/reportfilter/reportfilter.component.html
// module chunks = main